import { observable, IObservableArray, flow, toJS } from 'mobx';
import API from 'api';
import Practice from 'stores/Practice';
import Program from 'stores/Program';

export default class PracticeProgram {
	@observable id: number;
	@observable practiceID: number;
	@observable programID: number;
	@observable modified: string;
	@observable isDeleted: boolean = false;

	@observable Practice: Practice = new Practice();
	@observable Program: Program = new Program();

	constructor(data: PracticeProgram) {
		this.extend(data);
	}

	extend(data: JSON) {
		Object.assign(this, data);
	}

	update = flow(function*(withData) {
		if (withData) this.extend(withData);
		this.modified = new Date();
		if (this.isDeleted) {
			// Delete
			yield API.delete(`/PracticePrograms/${this.id}`);
		} else if (this.id) {
			// Update record
			yield API.patch(`/PracticePrograms/${this.id}`, toJS(this));
		} else {
			// New record
			let result = yield API.post(`/PracticePrograms`, toJS(this));
			this.id = result.id;
		}
	});
}



// WEBPACK FOOTER //
// ./src/stores/PracticeProgram.js